module.exports = __webpack_public_path__ + "static/find_stuff-068a6188e4a99c013f0a76ea6834b92d.svg";